/// <amd-module name="Release/Landing/Selection/SelectionActions" />
import { ActionsHubBase, Action } from "DistributedTask/Flux/Actions";
import { DefinitionEnvironmentReference } from "Release/Client/Contracts/Release";
import { ActiveDefinitionReferenceType } from "Release/Landing/DataProviderContracts";

export interface IDefinitionSelectionPayload {
    id: number;
    noSelection: boolean;
    folderId: string;
    updateHistoryState?: boolean;
}

export class SelectionActions extends ActionsHubBase {
    public static getKey(): string {
        return "release-landing-selection-actions";
    }

    public initialize(): void {
        this._selectDefinition = new Action<IDefinitionSelectionPayload>();
        this._selecteInitialDefinition = new Action<IDefinitionSelectionPayload>();
    }

    public get selectDefinition(): Action<IDefinitionSelectionPayload> {
        return this._selectDefinition;
    }

    public get selectInitialDefinition(): Action<IDefinitionSelectionPayload> {
        return this._selecteInitialDefinition;
    }

    private _selectDefinition: Action<IDefinitionSelectionPayload>;
    private _selecteInitialDefinition: Action<IDefinitionSelectionPayload>;
}
